// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { api } from "../Appjs/api";

// export const missedCallApi = createApi({
//   reducerPath: "missedCallApi",
//   baseQuery: fetchBaseQuery({
//     baseUrl: api,
//     prepareHeaders: (headers) => {
//       const token = localStorage.getItem("accessToken");
//       if (token) headers.set("Authorization", `Bearer ${token}`);
//       return headers;
//     },
//   }),
//   tagTypes: ["MissedCall"],

//   endpoints: (builder) => ({
//     // ----------------------------------------------------
//     // 1. GET MISSED CALL NUMBERS
//     // ----------------------------------------------------
//     getMissedCallNumbers: builder.query({
//       query: () => ({
//         url: "/missedcall/missedcall/numbers",
//         method: "GET",
//       }),
//       providesTags: ["MissedCallNumbers"],
//     }),

//     // ----------------------------------------------------
//     // 2. UPDATE MISSED CALL CONFIG
//     // ----------------------------------------------------
//     updateMissedCallConfig: builder.mutation({
//       query: (data) => ({
//         url: "/missedcall/update",
//         method: "POST",
//         body: data,
//       }),
//       invalidatesTags: ["MissedCallNumbers"],
//     }),

//     // ----------------------------------------------------
//     // 3. PRINCIPAL ENTITIES
//     // ----------------------------------------------------
//     fetchPrincipalEntities: builder.query({
//       query: () => ({
//         url: "/principal/getPrincipalEntities",
//         method: "GET",
//       }),
//       providesTags: ["Principal"],
//     }),

//     // ----------------------------------------------------
//     // 4. TEMPLATES BASED ON PRINCIPAL ID
//     // ----------------------------------------------------
//     getTemplatesByPrincipal: builder.query({
//       query: (principalId) => ({
//         url: `/template/templates/${principalId}`,
//         method: "GET",
//       }),
//     }),

//     // ----------------------------------------------------
//     // 5. HEADERS BASED ON PRINCIPAL
//     // ----------------------------------------------------
//     fetchHeadersByPrincipalId: builder.query({
//       query: (principalEntityId) => ({
//         url: `/header/get-selected-headers`,
//         method: "GET",
//         params: { principalEntityId },
//       }),
//       providesTags: ["Header"],
//     }),

//     // ----------------------------------------------------
//     // 6. GET CALL LOGS
//     // ----------------------------------------------------
//     getCallLogs: builder.query({
//       query: (params) => ({
//         url: "/missedcall/calllogs",
//         method: "GET",
//         params,
//       }),
//       providesTags: ["CallLogs"],
//     }),

//     searchCallLogs: builder.query({
//       query: (params) => ({
//         url: "/missedcall/search",
//         method: "GET",
//         params,
//       }),
//       providesTags: ["CallLogs"],
//     }),
//   }),
// });

// export const {
//   useGetMissedCallNumbersQuery,
//   useUpdateMissedCallConfigMutation,
//   useFetchPrincipalEntitiesQuery,
//   useGetTemplatesByPrincipalQuery,
//   useFetchHeadersByPrincipalIdQuery,
//   useGetCallLogsQuery,
//   useSearchCallLogsQuery

// } = missedCallApi;

import { createApi, fetchBaseQuery,  } from "@reduxjs/toolkit/query/react";
import { secureBaseQuery } from "./secureBaseQuery";
import {dynamicBaseQuery} from "./dynamicBaseQuery.js";
import { api } from "../../Appjs/api.js";

export const missedCallApi = createApi({
  reducerPath: "missedCallApi",
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
      //  baseQuery: dynamicBaseQuery,
  tagTypes: [
    "MissedCallNumbers",
    "Principal",
    "Header",
    "CallLogs",

    // NEW TAGS
    "Shortcodes",
    "Keywords",
    "Subkeywords",
    "ShortcodeKeywords",
    "ShortcodeSubKeywords",
    "ShortcodeMobiles",
    "ConfigData",
    "MissedCallFilterReport",
    "ShortcodeFilterReport",
  ],

  endpoints: (builder) => ({
    // ----------------------------------------------------
    // 1. GET MISSED CALL NUMBERS
    // ----------------------------------------------------
    getMissedCallNumbers: builder.query({
      query: () => ({
        url: "/missedcall/missedcall/numbers",
        method: "GET",
      }),
      providesTags: ["MissedCallNumbers"],
    }),

    // ----------------------------------------------------
    // 2. UPDATE MISSED CALL CONFIG
    // ----------------------------------------------------
    updateMissedCallConfig: builder.mutation({
      query: (data) => ({
        url: "/missedcall/update",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["MissedCallNumbers"],
    }),

    // ----------------------------------------------------
    // 3. PRINCIPAL ENTITIES
    // ----------------------------------------------------
    fetchPrincipalEntities: builder.query({
      query: () => ({
        url: "/principal/getPrincipalEntities",
        method: "GET",
      }),
      providesTags: ["Principal"],
    }),

    // ----------------------------------------------------
    // 4. TEMPLATES BASED ON PRINCIPAL ID
    // ----------------------------------------------------
    getTemplatesByPrincipal: builder.query({
      query: (principalId) => ({
        url: `/template/templates/${principalId}`,
        method: "GET",
      }),
    }),

    // ----------------------------------------------------
    // 5. HEADERS BASED ON PRINCIPAL
    // ----------------------------------------------------
    fetchHeadersByPrincipalId: builder.query({
      query: (principalEntityId) => ({
        url: `/header/get-selected-headers`,
        method: "GET",
        params: { principalEntityId },
      }),
      providesTags: ["Header"],
    }),

    // ----------------------------------------------------
    // 6. GET CALL LOGS
    // ----------------------------------------------------
    getCallLogs: builder.query({
      query: (params) => ({
        url: "/missedcall/calllogs",
        method: "GET",
        params,
      }),
      providesTags: ["CallLogs"],
    }),

    // SEARCH
    searchCallLogs: builder.query({
      query: (params) => ({
        url: "/missedcall/search",
        method: "GET",
        params,
      }),
      providesTags: ["CallLogs"],
    }),

    getShortcodes: builder.query({
      query: () => ({
        url: "/missedcall/shortcodes",
        method: "GET",
      }),
      providesTags: ["Shortcodes"],
    }),

    // 2) Get Keywords for selected Shortcode
    getKeywordsByShortcode: builder.query({
      query: (shortcode) => ({
        url: `/missedcall/shortcode/${shortcode}/keywords`,
        method: "GET",
      }),
      providesTags: (result, error, shortcode) => [
    { type: "Keywords", id: shortcode },
  ],
    }),

    // 3) Get Subkeywords for selected Keyword
    getSubkeywordsByKeyword: builder.query({
      query: (keywordId) => ({
        url: `/missedcall/keyword/${keywordId}/subkeywords`,
        method: "GET",
      }),
      providesTags: ["Subkeywords"],
    }),

    // 4) Get Templates + Headers
    getConfigData: builder.query({
      query: () => ({
        url: "/missedcall/config/data",
        method: "GET",
      }),
      providesTags: ["ConfigData"],
    }),

    // 5) Save Subkeyword Response
    saveSubkeywordResponse: builder.mutation({
      query: (data) => ({
        url: "/missedcall/keyword/update",
        method: "POST",
        body: data,
      }),
        invalidatesTags: ["Keywords"],
    }),

    getShortcodeReport: builder.query({
      query: (params) => ({
        url: "/missedcall/shortcode/report",
        method: "GET",
        params,
      }),
    }),

    // 1) Missedcall Filter Report
    getMissedCallFilterReport: builder.query({
      query: (params) => ({
        url: "/missedcall/missedcall/filter-report",
        method: "GET",
        params,
      }),
      providesTags: ["MissedCallFilterReport"],
    }),

    // 2) Shortcode Filter Report
    getShortcodeFilterReport: builder.query({
      query: (params) => ({
        url: "/missedcall/shortcode/filter-report",
        method: "GET",
        params,
      }),
      providesTags: ["ShortcodeFilterReport"],
    }),

    // 3) Get Missedcall Numbers for dropdown (new route)
    getMissedCallNumbersTwo: builder.query({
      query: () => ({
        url: "/missedcall/numbers-two",
        method: "GET",
      }),
      providesTags: ["MissedCallNumbers"],
    }),

    // 4) Get Shortcodes for dropdown (new route)
    getShortcodesTwo: builder.query({
      query: () => ({
        url: "/shortcodes-two",
        method: "GET",
      }),
      providesTags: ["Shortcodes"],
    }),

    // Add these to your missedCallApi
    getShortcodeKeywords: builder.query({
      query: (params) => ({
        url: "/missedcall/shortcode/keywords",
        method: "GET",
        params,
      }),
      providesTags: ["ShortcodeKeywords"],
    }),
    getShortcodeSubKeywords: builder.query({
      query: (params) => ({
        url: "/missedcall/shortcode/subkeywords",
        method: "GET",
        params,
      }),
      providesTags: ["ShortcodeSubKeywords"],
    }),

    getShortcodeMobiles: builder.query({
      query: (params) => ({
        url: "/missedcall/shortcode/mobiles",
        method: "GET",
        params,
      }),
      providesTags: ["ShortcodeMobiles"],
    }),

    saveFilterReport: builder.mutation({
      query: (payload) => ({
        url: "/filter/save-report",
        method: "POST",
        body: payload,
      }),
      providesTags: ["ShortcodeSubKeywords"],
    }),
downloadCallLogs: builder.query({
  query: (params) => ({
    url: "/missedcall/shortcode/report/download", // ✅ correct route
    method: "GET",
    params,
    responseHandler: (response) => response.blob(),
  }),
}),
downloadMissedCallTableLogs: builder.query({
  query: (params) => ({
    url: "/missedcall/search/table-download",
    method: "GET",
    params,
    responseHandler: (response) => response.blob(),
  }),
}),
  }),
});

// EXPORT hooks
export const {
  useGetMissedCallNumbersQuery,
  useUpdateMissedCallConfigMutation,
  useFetchPrincipalEntitiesQuery,
  useGetTemplatesByPrincipalQuery,
  useFetchHeadersByPrincipalIdQuery,
  useGetCallLogsQuery,
  useSearchCallLogsQuery,

  // ⭐ NEW HOOKS
  useGetShortcodesQuery,
  useGetKeywordsByShortcodeQuery,
  useGetSubkeywordsByKeywordQuery,
  useGetConfigDataQuery,
  useSaveSubkeywordResponseMutation,
  useGetShortcodeReportQuery,

  // ⭐ NEW FILTER REPORT HOOKS
  useGetMissedCallFilterReportQuery,
  useGetShortcodeFilterReportQuery,
  useGetMissedCallNumbersTwoQuery,
  useGetShortcodesTwoQuery,
  useGetShortcodeKeywordsQuery,
  useGetShortcodeSubKeywordsQuery,
  useGetShortcodeMobilesQuery,
  useSubmitViewDBFiltersMutation,
  useGetdbfildsFilterQuery,
  useSaveFilterReportMutation,
  useLazyDownloadCallLogsQuery,
  useLazyDownloadMissedCallTableLogsQuery,
} = missedCallApi;
